import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=c6cf32a8&scoped=true&"
import script from "./DealerList.vue?vue&type=script&lang=js&"
export * from "./DealerList.vue?vue&type=script&lang=js&"
import style0 from "./DealerList.vue?vue&type=style&index=0&id=c6cf32a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cf32a8",
  null
  
)

export default component.exports